import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const authService = {
  logout,
  login,
  loginGoogle
};

function loginGoogle(code) {
  const formData = new FormData();
  formData.append('code', code);
  formData.append('clientName', 'google');
  formData.append('grant_type', 'password');
  formData.append('scope', 'read');
  formData.append('client_id', 'backoffice');
  formData.append('type', 'password');
  formData.append('applicationCode', 'BO');

  return submit(
    'POST',
    `${API_ENDPOINT}/oauth/token`,
    {},
    {
      headers: {
        Authorization: 'Basic YmFja29mZmljZTpQQHNzdzByZA==',
      },
      body: formData,
    },
  );
}

function login(data){
  const formData = new FormData();
  formData.append('grant_type','password');
  formData.append('username',data.userid); // SUPER_USER
  formData.append('password',data.password); // test
  formData.append('scope','read');
  formData.append('client_id','backoffice');
  formData.append('type','password');
  formData.append('applicationCode','BO');

  return submit(
    'POST',
    `${API_ENDPOINT}/oauth/token`,
    {},
    {
      headers: {
        Authorization: 'Basic YmFja29mZmljZTpQQHNzdzByZA==',
      },
      body: formData,
    }
  );
}

function logout(data) {
  const { user_name, loginId } = data;
  const dataToSend = {
    userId: user_name,
    loginId: loginId
  };

  return submit(
    'POST',
    `${API_ENDPOINT}/api/v1/ekyc/logout`,
    dataToSend,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
    false,
  );
}

export default authService;
